<app-context-menu
  [options]="{
    openOnHover: true,
    width: containsVideo() ? '360px' : '240px',
    interactionDisabled: true,
    autoShrink: true,
  }"
  [disabled]="!htmlContent()"
  verticalPosition="top"
  #menu
>
  <div contextButton>
    <ng-content></ng-content>
  </div>
  <div contextContent>
    @if (menu.isOpenSignal()) {
      <app-tooltip-content
        [htmlContent]="htmlContent()"
        [imageOrVideoUrl]="imageOrVideoUrl() | storyblokCdn"
        [title]="title()"
      ></app-tooltip-content>
    }
  </div>
</app-context-menu>
